module.exports = __webpack_public_path__ + "static/img/keybord.895c42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keybord.png
// module id = CDkA
// module chunks = 1